import "./App.css";
import ExystSpace3 from "./pages/exystSpace3/ExystSpace3";
import LoadCurtain from "./components/LoadCurtain/LoadCurtain";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

// ── Archived pages (commented out — restore when needed) ──────────────────
// import ExystSpace from "./pages/exystSpace/ExystSpace";
// import ExystSpace2 from "./pages/exystSpace2/ExystSpace2";
// import SectionOne from "./components/sectionOne/SectionOne";
// import SectionTwo from "./components/sectionTwo/SectionTwo";
// import SectionThree from "./components/sectionThree/SectionThree";
// import SectionFour from "./components/sectionFour/SectionFour";
// import SectionFive from "./components/sectionFive/SectionFive";
// import SectionSix from "./components/sectionSix/SectionSix";
// import SectionOneMobile from "./components/sectionOneMobile/SectionOneMobile";
// import SectionTwoMobile from "./components/sectionTwoMobile/SectionTwoMobile";
// import SectionThreeMobile from "./components/sectionThreeMobile/SectionThreeMobile";
// import SectionFourMobile from "./components/sectionFourMobile/SectionFourMobile";
// import SectionFiveMobile from "./components/sectionFiveMobile/SectionFiveMobile";
// import SectionSixMobile from "./components/sectionSixMobile/SectionSixMobile";

const path = window.location.pathname;

function App() {
  if (path === "/admin" || path === "/admin/login") return <AdminLogin />;
  if (path === "/admin/dashboard") return <AdminDashboard />;
  return <><LoadCurtain delay={900} /><ExystSpace3 /></>;
}

export default App;

// ── Archived routing (restore when multi-page is back) ────────────────────
// const path = window.location.pathname;
// const isSpacePage = path === "/" || path === "/space" || path.startsWith("/space/");
// const isSpace2Page = path.startsWith("/exyst-space-2");
// const isSpace3Page = path.startsWith("/exyst-space-3");
// const isPartnerPage = path.startsWith("/exyst-partner");
//
// if (isSpacePage) return <><LoadCurtain /><ExystSpace /></>;
// if (isSpace2Page) return <><LoadCurtain /><ExystSpace2 /></>;
// if (isSpace3Page) return <><LoadCurtain delay={900} /><ExystSpace3 /></>;
